import script from "./AlertMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertMain.vue?vue&type=script&setup=true&lang=js"

import "./AlertMain.vue?vue&type=style&index=0&id=1e51195a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e51195a"]])

export default __exports__